module.exports = __webpack_public_path__ + "static/media/excited-lively.88b4229a.png";